import React from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import GuardsNewList from "../Guards/GuardsNewList";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { makeGetRequest, makePostRequest } from "../../../utils/utils";
import swal from "sweetalert";

import InputAdornment from "@mui/material/InputAdornment";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";

// End

function Guards() {
  const navigate = useNavigate();

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [showLoader, setShowLoader] = React.useState(false);

  const handleClickOpen = (scrollType) => () => {
    // getLoginCode()
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [loginCode, setLoginCode] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [errorMsg, setErrorMessage] = React.useState("");
  const [confirmErrorMsg, setConfirmErrorMessage] = React.useState("");
  // const [successMsg, setSuccessMessage] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [isCommonGuardUpdate, SetIsCommonGuardUpdate] = React.useState(false);
  const [isChangePassword, SetIsChangePassword] = React.useState(false);

  const [guardId, setguardId] = React.useState();
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  async function getLoginCode() {
    setShowLoader(true);
    await makeGetRequest("guards/getCode")
      .then((response) => {
        if (response.data.data !== undefined) {
          setLoginCode(response.data.data.getCode);
        } else {
        }
        setShowLoader(false);
      })
      .catch((err) => {
        swal("There was an error!", err.message, "warning");
      });
  }

  async function handleChangeConfirmPassword(newValue) {
    if (newPassword !== newValue) {
      // setSuccessMessage("");
      setConfirmErrorMessage("Password Not Matched");
      setConfirmPassword(newValue);
    } else {
      // setSuccessMessage("Password Verified");
      setConfirmErrorMessage("");
      setConfirmPassword(newValue);
      document.getElementById("submitPassword").disabled = false;
    }
  }

  async function validatePassword(password) {
    var lowerCase = /[a-z]/g;
    var upperCase = /[A-Z]/g;
    var numbers = /[0-9]/g;
    // var specialChar = /[!@#\$%\^\&\b*\)\(+=._-]/g;
    var specialChar = /[!@#$%^&*()+=._-]/g;

    if (!password.match(lowerCase)) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else if (!password.match(upperCase)) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else if (!password.match(numbers)) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else if (!password.match(specialChar)) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else if (password.length < 8) {
      setErrorMessage(
        "Password should be minimum 8 character long and a combination of uppercase letters, lowercase letters, numbers, and symbols!"
      );
      setNewPassword();
    } else {
      setErrorMessage("");
      setNewPassword(password);
      document.getElementById("confirmPassword").disabled = false;
    }
  }

  // For Eye 2
  const [showPassword2, setShowPassword2] = React.useState(false);

  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

  const handleMouseDownPassword2 = (event) => {
    event.preventDefault();
  };
  // End

  async function addguardsfun() {
    if (newPassword !== "") {
      if (isCommonGuardUpdate) {
        let inputdata = {
          guardidentitycode: loginCode,
          password: newPassword,
          iscommonguard: true,
          society_id: localStorage.getItem("socityid"),
          society_code: localStorage.getItem("societyCode"),
          guard_id: guardId
        };
        
        await makePostRequest("guards/update/CommonGuard", inputdata)
          .then((response) => {
            if (response.data.data !== undefined) {
              swal("Success", "Guard Updated Successfully", "success", {
                timer: 3000,
                buttons: false,
              });
              navigate("/Guards");
            } else {
            }
          })
          .catch((err) => {
            swal("There was an error!", "more error details", "warning");
          });
      } else {
        let inputdata = {
          guardidentitycode: loginCode,
          guard_name: localStorage.getItem("societyName") + " Guard",
          language: "English",
          password: newPassword,
          iscommonguard: true,
          society_id: localStorage.getItem("socityid"),
          society_code: localStorage.getItem("societyCode"),
        };
        await makePostRequest("guards/insert/CommonGuard", inputdata)
          .then((response) => {
            if (response.data.data !== undefined) {
              swal("Success", "Guard Added Successfully", "success", {
                timer: 3000,
                buttons: false,
              });
              navigate("/Guards");
            } else {
            }
          })
          .catch((err) => {
            swal("There was an error!", "more error details", "warning");
          });
      }

      setNewPassword("");
      setConfirmPassword("");
      setConfirmErrorMessage("");
      window.location.reload();
    } else {
      setErrorMessage("Required");
    }
  }

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    makeGetRequest("guards/getcommonguard")
      .then((response) => {
        if (response.data.data !== undefined) {
          console.log(response.data.data);
          if (response.data.data) {
            SetIsCommonGuardUpdate(true);
            setLoginCode(response.data.data.guardidentitycode);
            setguardId(response.data.data.guard_id);
          }
        } else {
          getLoginCode();
          SetIsCommonGuardUpdate(false);
          SetIsChangePassword(true);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        swal("There was an error!", err.message, "warning");
      });
  }, [open]);
  // End

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Guards</h1>

            <Button
              className="contentTopLefBt"
              onClick={() => navigate("/AddGuards")}
            >
              Add Guard
            </Button>
            <Button className="primaryBtn" onClick={handleClickOpen("body")}>
              Guard App Login
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <GuardsNewList />
            </div>
          </Grid>
        </Grid>

        <div className="modalMain guardCommnModalMain">
          <Dialog
            open={open}
            // onClose={handleClose}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
          >
            <DialogTitle id="scroll-dialog-title" className="modalHeading">
              <span>Guard App Login</span>
              <CloseIcon className="modalCloseBt" onClick={handleClose} />
            </DialogTitle>
            <DialogContent dividers={scroll === "paper"}>
              <div className="guardCommnModalMain">
                <div className="modalInnerCont">
                  <div className="succefullAdd">
                    <Grid container spacing={3} className="addCommitee1">
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">
                          Guard Identity Code{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className="modalInputStSelect"
                          value={loginCode}
                          disabled
                        />
                        {/* <div className="errorField">Error message here..!</div> */}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">
                          Society Code <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className="modalInputStSelect"
                          value={localStorage.getItem('societyCode')}
                          disabled
                        />
                        {/* <div className="errorField">Error message here..!</div> */}
                      </Grid>
                      {isCommonGuardUpdate ? (
                        <>
                          {/* Change Password */}
                          <Grid item xs={12} md={12}>
                            <span
                              className="changePass"
                              onClick={() =>
                                SetIsChangePassword(!isChangePassword)
                              }
                            >
                              Change Password{" "}
                            </span>
                          </Grid>
                        </>
                      ) : (
                        <></>
                      )}

                      {isChangePassword ? (
                        <>
                          <Grid item xs={12} md={12}>
                            <label className="tabsLabel">
                              {isCommonGuardUpdate ? (
                                <>Enter New Password </>
                              ) : (
                                <>Enter Password </>
                              )}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Input
                              className="modalInputStSelect"
                              placeholder="Enter Password"
                              id="passwordId"
                              value={newPassword}
                              onChange={(e) => validatePassword(e.target.value)}
                              type={showPassword ? "text" : "password"}
                              startAdornment={
                                <InputAdornment position="start">
                                  <LockOpenIcon />
                                </InputAdornment>
                              }
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                  >
                                    {showPassword ? (
                                      <VisibilityOff />
                                    ) : (
                                      <Visibility />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                            />

                            <div className="errorField">{errorMsg}</div>
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <label className="tabsLabel">
                              Confirm Password{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            {/* <input className="modalInputStSelect" /> */}
                            <Input
                              placeholder="Confirm Password"
                              className="modalInputStSelect"
                              id="confirmPassword"
                              value={confirmPassword}
                              onChange={(e) =>
                                handleChangeConfirmPassword(e.target.value)
                              }
                              type={showPassword2 ? "text" : "password"}
                              startAdornment={
                                <InputAdornment position="start">
                                  <LockOpenIcon />
                                </InputAdornment>
                              }
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword2}
                                    onMouseDown={handleMouseDownPassword2}
                                    edge="end"
                                  >
                                    {showPassword2 ? (
                                      <VisibilityOff />
                                    ) : (
                                      <Visibility />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                            />
                            <div className="errorField">{confirmErrorMsg}</div>
                          </Grid>
                        </>
                      ) : (
                        <></>
                      )}
                      <Grid item xs={12} md={12}>
                        <div className="modalMainBtMain">
                          {isCommonGuardUpdate ? (
                            <Button
                              className="modalMainBt"
                              onClick={() => addguardsfun()}
                            >
                              Update
                            </Button>
                          ) : (
                            <Button
                              className="modalMainBt"
                              onClick={() => addguardsfun()}
                            >
                              Submit
                            </Button>
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default Guards;
